import { render, staticRenderFns } from "./studentrollcall.vue?vue&type=template&id=6792bd80&"
import script from "./studentrollcall.vue?vue&type=script&lang=js&"
export * from "./studentrollcall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports